import React, { useState, Fragment } from 'react';
import { Box, Typography, Button, Link, List, ListItem, ListItemIcon, TextField, CircularProgress } from '@material-ui/core';
import { DeleteOutline, EditOutlined } from '@material-ui/icons';
import { makeStyles } from "@material-ui/core/styles";
import icWhiteAdd from '../assets/icons/white-add.png';
import PropTypes from 'prop-types';
import icDots from '../assets/icons/icBlueAdd.png';
import FilePopover from './file-popover';
import { useTranslate } from 'react-admin';
import {
    usePopupState,
    bindToggle,
} from 'material-ui-popup-state/hooks'
import colors from '../CustomizedUIs/Colors';
import { getFileNameWithoutExtension } from '../utils';

const itemStyles = makeStyles(theme => ({
    container: {
        backgroundColor: '#f3f7fa',
        padding: theme.spacing(1),
        marginBottom: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
        borderRadius: 4,
    },
    btn: {
        padding: 5,
        minWidth: 'unset',
        width: 25,
        height: 25,
        backgroundColor: '#ffffff',
        borderRadius: 10,
        border: 'solid 2px #e5f1f8;',
    },
    btnSelect: {
        padding: 5,
        minWidth: 'unset',
        width: 25,
        height: 25,
        backgroundColor: '#237fc2',
        borderRadius: 10,
        border: 'solid 2px #e5f1f8;',
        '&:hover': {
            backgroundColor: '#237fc2',
        }
    },
    btnIcon: {
        width: 14,
        height: 14
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: '#f3f7fa !important'
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    input: {
        backgroundColor: '#f3f7fa',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: '#f3f7fa'
        }
    },
    text: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.13px",
        color: "#4f5064",

    },
    textSmall: {
        cursor: 'pointer',
        fontFamily: "UniviaPro-Book",
        fontSize: "11px",
        fontWeight: 'normal',
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#88898c"
    },
    iconPopover: {
        minWidth: 30
    },
    titlePopover: {
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.13px",
    },

}));

const errorItemStyles = makeStyles(theme => ({
    container: {
        backgroundColor: '#ce5454',
        padding: theme.spacing(1),
        marginBottom: theme.spacing(1),
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: 'solid 1px lightgrey',
        borderRadius: 4,
        position: 'relative'
    },
    text: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.13px",
        color: "#fafefe",

    },
    textName: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontFamily: "UniviaPro-Book",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.13px",
        color: "#fafefe",

    },
    btn: {
        minWidth: 'unset',
        padding: 5,
        backgroundColor: '#ffffff',
        position: 'absolute',
        right: 6,
        top: 40,
        width: 25,
        height: 25,
        borderRadius: 10,
        border: 'solid 2px #ce5454',
        '&:hover': {
            backgroundColor: '#e5f1f8',
        },
        padding:'5px 5px'
    },
    btnSelect: {
        minWidth: 'unset',
        padding: 5,
        backgroundColor: '#237fc2',
        position: 'absolute',
        right: 6,
        top: 40,
        width: 25,
        height: 25,
        borderRadius: 10,
        border: 'solid 2px #ce5454',
        '&:hover': {
            backgroundColor: '#e5f1f8',
        }
    },
    btnIcon: {
        width: 14,
        height: 14
    },
    override: {
        cursor: 'pointer',
        '&:active': {
            opacity: 0.7
        },

        textDecoration: 'underline',
        fontFamily: "UniviaPro",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#fafefe"
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: '#f3f7fa !important'
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    input: {
        backgroundColor: '#f3f7fa',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: '#f3f7fa'
        }
    },
    textSmallOverrideFile: {
        cursor: 'pointer',
        textDecoration: 'underline',
        fontFamily: "UniviaPro-Book",
        fontSize: "11px",
        fontWeight: 'normal',
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#ffffff"
    },
    textSmall: {
        cursor: 'pointer',
        fontFamily: "UniviaPro-Book",
        fontSize: "11px",
        fontWeight: 'normal',
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#ffffff"
    },
    textError: {
        fontFamily: "UniviaPro-Book",
        fontSize: "10px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.5,
        letterSpacing: "normal",
        color: "#ffffff"
    }
}));

let extension;
function FileItem({ file, onDelete, onRename, onOverrideFile, index }) {
    const translate = useTranslate();
    const { name, size, error, loading } = file;
    const classes = error ? errorItemStyles() : itemStyles();
    const popupState = usePopupState({ variant: 'popper', popupId: 'itemUpload' + index });
    const fileName = name.split('.');
    extension = fileName[fileName.length - 1];

    const [showRename, setShowRename] = useState(false);
    const [textValue, setTextValue] = React.useState({
        name: getFileNameWithoutExtension(name)
    });
    const [validate, setValidate] = React.useState({
        name: {
            isError: true,
            message: ''
        },
    });

    const deleteFile = () => {
        onDelete();
        popupState.close();
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            popupState.close();
            onRename(textValue.name + "." + extension);
            setShowRename(false);
        }
    }

    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validateFc(prop, e.target.value)
    }

    const validateFc = (prop, value) => {
        if (prop === 'name') {
            if (value.length === 0)

                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                            isError: false, message: ''
                        }
                })
            else {
                const test = (/[*|\\:\/"<>?]/).test(value)
                setValidate({
                    ...validate, [prop]: test === true ? {
                        isError: true, message: "A file name can't contain any of the following characters: \\/:*?”<>| "
                    } : {
                            isError: false, message: ''
                        }
                })
            }
        }
        else
            setValidate({
                ...validate, [prop]: value.length === 0 ? {
                    isError: true, message: 'required'
                } : {
                        isError: false, message: ''
                    }
            })

    }

    return (
        <Fragment>
            {
                error ? (
                    <Box className={classes.container}>
                        <Typography className={classes.textName}>{name}</Typography>
                        <Typography style={{ paddingTop: "9px" }} className={classes.textSmall}>{size}</Typography>
                        <Typography style={{ paddingTop: "9px" }} className={classes.textError}>{translate('pos.categories.FileExist')}</Typography>
                        <Link style={{ paddingTop: "9px" }} className={classes.textSmallOverrideFile} onClick={onOverrideFile}>{translate('pos.categories.OverrideFile')}</Link>
                        {popupState.isOpen ?
                            <Button className={classes.btnSelect} {...bindToggle(popupState)} >
                                <img alt='' src={icWhiteAdd} className={classes.btnIcon} />
                            </Button>
                            :
                            <Button className={classes.btn} {...bindToggle(popupState)}>
                                <img alt='' src={icDots} className={classes.btnIcon} />
                            </Button>
                        }
                    </Box>
                ) : (
                        <Box className={classes.container}>
                            <Box flexGrow={1}>
                                <Box style={{ maxWidth: '150px' }}>
                                    <Typography style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}} className={classes.textName} >{name}</Typography>
                                </Box>
                                <Typography style={{ padding: "4px" }} className={classes.textSmall}>{size}</Typography>
                            </Box>
                            {
                                loading ? <CircularProgress style={{ width: 24, height: 24 }} /> :
                                    (popupState.isOpen ?
                                        <Button className={classes.btnSelect} {...bindToggle(popupState)}  >
                                            <img alt='' src={icWhiteAdd} className={classes.btnIcon} />
                                        </Button>
                                        :
                                        <Button className={classes.btn} {...bindToggle(popupState)}>
                                            <img alt='' src={icDots} className={classes.btnIcon} />
                                        </Button>)
                            }
                        </Box>
                    )
            }

            <FilePopover popupState={popupState}>
                <List component="nav" aria-label="main mailbox folders">
                    {
                        showRename ? (
                            <ListItem>
                                <TextField
                                    label={translate(`pos.categories.enterName`)}
                                    autoFocus={true}
                                    onKeyDown={(!validate.name.message != "" && !validate.name.isError) && onKeyDown}
                                    required
                                    onBlur={() => {
                                        validateFc('name', textValue.name)
                                    }}
                                    value={textValue.name}
                                    error={validate.name.message != "" && validate.name.isError}
                                    helperText={validate.name.message}
                                    fullWidth
                                    onChange={textOnChange('name')}
                                    variant="filled"
                                    InputProps={{
                                        className: classes.input,
                                        classes: {
                                            underline: textValue.name !== '' ? classes.underline : classes.underlineNotValue,
                                            focused: classes.focuses
                                        }
                                    }}
                                />
                            </ListItem>
                        ) : (
                                <ListItem button onClick={() => setShowRename(true)}>
                                    <ListItemIcon className={classes.iconPopover}>
                                        <EditOutlined />
                                    </ListItemIcon>
                                    <Typography className={classes.titlePopover}>{translate('pos.categories.Rename')}</Typography>
                                </ListItem>
                            )
                    }
                    <ListItem button onClick={deleteFile}>
                        <ListItemIcon className={classes.iconPopover}>
                            <DeleteOutline />
                        </ListItemIcon>
                        <Typography className={classes.titlePopover}>{translate('pos.categories.Delete')}</Typography>
                    </ListItem>
                </List>
            </FilePopover>
        </Fragment>
    );
}

FileItem.propTypes = {
    file: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    onRename: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired
};

export default FileItem;
